/**
 * Travel 登入／註冊、密碼欄位無障礙文案與「＋」建立選單文案。
 * 後端回傳的錯誤訊息原樣顯示，不在此翻譯。
 */
import { createFlatMessageLookup } from './flatMessages';

const L = 'travel.auth.login';
const R = 'travel.auth.register';
const A = 'travel.auth';
const C = 'travel.create';

export const travelEntryMessagesZhTW = {
  [`${A}.emailVerificationAccepted`]: '請求已受理；符合條件時將嘗試寄送，尚不代表已寄出或送達。未收到可稍後重試。',
  [`${A}.password.show`]: '顯示密碼',
  [`${A}.phone.country`]: '國家／地區',
  [`${A}.phone.loading`]: '載入國家／地區…',
  [`${A}.phone.select`]: '選擇國家／地區',
  [`${A}.phone.code`]: '區碼',
  [`${A}.phone.codeLabel`]: '電話區碼',
  [`${A}.password.hide`]: '隱藏密碼',
  [`${A}.or`]: '或',
  [`${A}.email`]: '電子郵件',
  [`${A}.mobile`]: '手機',
  [`${A}.googleCredentialMissing`]: 'Google 未回傳登入憑證。',
  [`${A}.googleFailed`]: 'Google 登入失敗，請稍後再試。',

  [`${L}.title`]: '登入',
  [`${L}.subtitle`]: '使用既有的 Formosa 會員帳號。',
  [`${L}.methodLabel`]: '登入方式',
  [`${L}.account`]: '帳號',
  [`${L}.password`]: '密碼',
  [`${L}.rememberMe`]: '記住我',
  [`${L}.forgotPassword`]: '忘記密碼？',
  [`${L}.submit`]: '登入',
  [`${L}.submitting`]: '登入中…',
  [`${L}.guest`]: '以訪客瀏覽',
  [`${L}.noAccount`]: '還沒有帳號？',
  [`${L}.registerLink`]: '註冊',
  [`${L}.failed`]: '無法登入，請稍後再試。',

  [`${R}.title`]: '建立帳號',
  [`${R}.subtitle`]: '使用 Formosa 會員帳號註冊。',
  [`${R}.methodLabel`]: '註冊方式',
  [`${R}.username`]: '使用者名稱',
  [`${R}.password`]: '密碼（6–12 字，不含空格）',
  [`${R}.nickname`]: '顯示名稱（選填）',
  [`${R}.inviterRequired`]: '邀請碼（必填）',
  [`${R}.inviterOptional`]: '邀請碼（選填）',
  [`${R}.verifyCode`]: '驗證碼',
  [`${R}.sendCode`]: '送出驗證碼',
  [`${R}.sendingCode`]: '送出中…',
  [`${R}.resendIn`]: '請於 {count} 秒後重送',
  [`${R}.codeSent`]: '驗證碼已送出',
  [`${R}.codeFailed`]: '驗證碼送出失敗',
  [`${R}.emailRequired`]: '請輸入電子郵件',
  [`${R}.mobileRequired`]: '請輸入手機號碼',
  [`${R}.agreeRequired`]: '請先同意使用者條款與隱私權政策',
  [`${R}.agree`]: '我同意使用者條款與隱私權政策',
  [`${R}.legalLinksLabel`]: '條款與政策',
  [`${R}.terms`]: '使用者條款',
  [`${R}.privacy`]: '隱私權政策',
  [`${R}.submit`]: '建立帳號',
  [`${R}.submitting`]: '建立中…',
  [`${R}.failed`]: '註冊失敗',
  [`${R}.haveAccount`]: '已經有帳號？',
  [`${R}.loginLink`]: '登入',

  [`${C}.trigger`]: '建立',
  [`${C}.open`]: '建立內容',
  [`${C}.close`]: '關閉建立選單',
  [`${C}.title`]: '新增',
  [`${C}.subtitle`]: '選擇你想開始的內容',
  [`${C}.cancel`]: '取消',
  [`${C}.post.label`]: '發布貼文',
  [`${C}.post.description`]: '分享多圖、GIF、貼圖或音樂',
  [`${C}.journey.label`]: '建立行程',
  [`${C}.journey.description`]: '接續既有建立行程流程',
  [`${C}.group-trip.label`]: '發起揪團',
  [`${C}.group-trip.description`]: '從自己已發布的行程發起',
  [`${C}.checkin.label`]: '打卡',
  [`${C}.checkin.description`]: '記錄你到過的地點',
};

export const travelEntryMessagesEnUS = {
  [`${A}.emailVerificationAccepted`]: 'Request accepted. Delivery will be attempted if eligible; sending and receipt are not guaranteed. Retry later if needed.',
  [`${A}.password.show`]: 'Show password',
  [`${A}.phone.country`]: 'Country / region',
  [`${A}.phone.loading`]: 'Loading countries…',
  [`${A}.phone.select`]: 'Select country / region',
  [`${A}.phone.code`]: 'Code',
  [`${A}.phone.codeLabel`]: 'Phone area code',
  [`${A}.password.hide`]: 'Hide password',
  [`${A}.or`]: 'or',
  [`${A}.email`]: 'Email',
  [`${A}.mobile`]: 'Mobile',
  [`${A}.googleCredentialMissing`]: 'Google didn’t return a sign-in credential.',
  [`${A}.googleFailed`]: 'Google sign-in failed. Please try again later.',

  [`${L}.title`]: 'Sign in',
  [`${L}.subtitle`]: 'Use your existing Formosa member account.',
  [`${L}.methodLabel`]: 'Sign-in method',
  [`${L}.account`]: 'Username',
  [`${L}.password`]: 'Password',
  [`${L}.rememberMe`]: 'Remember me',
  [`${L}.forgotPassword`]: 'Forgot password?',
  [`${L}.submit`]: 'Sign in',
  [`${L}.submitting`]: 'Signing in…',
  [`${L}.guest`]: 'Browse as a guest',
  [`${L}.noAccount`]: 'Don’t have an account?',
  [`${L}.registerLink`]: 'Create one',
  [`${L}.failed`]: 'Unable to sign in. Please try again later.',

  [`${R}.title`]: 'Create an account',
  [`${R}.subtitle`]: 'Sign up for a Formosa member account.',
  [`${R}.methodLabel`]: 'Sign-up method',
  [`${R}.username`]: 'Username',
  [`${R}.password`]: 'Password (6–12 characters, no spaces)',
  [`${R}.nickname`]: 'Display name (optional)',
  [`${R}.inviterRequired`]: 'Invite code (required)',
  [`${R}.inviterOptional`]: 'Invite code (optional)',
  [`${R}.verifyCode`]: 'Verification code',
  [`${R}.sendCode`]: 'Send code',
  [`${R}.sendingCode`]: 'Sending…',
  [`${R}.resendIn_one`]: 'Resend in {count} second',
  [`${R}.resendIn`]: 'Resend in {count} seconds',
  [`${R}.codeSent`]: 'Verification code sent',
  [`${R}.codeFailed`]: 'Couldn’t send the verification code',
  [`${R}.emailRequired`]: 'Please enter your email',
  [`${R}.mobileRequired`]: 'Please enter your mobile number',
  [`${R}.agreeRequired`]: 'Please agree to the Terms of Service and Privacy Policy first',
  [`${R}.agree`]: 'I agree to the Terms of Service and Privacy Policy',
  [`${R}.legalLinksLabel`]: 'Terms and policies',
  [`${R}.terms`]: 'Terms of Service',
  [`${R}.privacy`]: 'Privacy Policy',
  [`${R}.submit`]: 'Create account',
  [`${R}.submitting`]: 'Creating…',
  [`${R}.failed`]: 'Sign-up failed',
  [`${R}.haveAccount`]: 'Already have an account?',
  [`${R}.loginLink`]: 'Sign in',

  [`${C}.trigger`]: 'Create',
  [`${C}.open`]: 'Create something',
  [`${C}.close`]: 'Close create menu',
  [`${C}.title`]: 'Create',
  [`${C}.subtitle`]: 'Choose what you want to start',
  [`${C}.cancel`]: 'Cancel',
  [`${C}.post.label`]: 'New post',
  [`${C}.post.description`]: 'Share photos, GIFs, stickers, or music',
  [`${C}.journey.label`]: 'New trip',
  [`${C}.journey.description`]: 'Continue with the usual trip setup',
  [`${C}.group-trip.label`]: 'Start a group trip',
  [`${C}.group-trip.description`]: 'Start from a trip you’ve published',
  [`${C}.checkin.label`]: 'Check in',
  [`${C}.checkin.description`]: 'Record a place you’ve been',
};

export const travelEntryMessagesZhCN = {
  [`${A}.emailVerificationAccepted`]: '请求已受理；符合条件时将尝试寄送，尚不代表已寄出或送达。未收到可稍后重试。',
  [`${A}.password.show`]: '显示密码',
  [`${A}.phone.country`]: '国家／地区',
  [`${A}.phone.loading`]: '加载国家／地区…',
  [`${A}.phone.select`]: '选择国家／地区',
  [`${A}.phone.code`]: '区号',
  [`${A}.phone.codeLabel`]: '电话区号',
  [`${A}.password.hide`]: '隐藏密码',
  [`${A}.or`]: '或',
  [`${A}.email`]: '电子邮箱',
  [`${A}.mobile`]: '手机',
  [`${A}.googleCredentialMissing`]: 'Google 未返回登录凭证。',
  [`${A}.googleFailed`]: 'Google 登录失败，请稍后再试。',

  [`${L}.title`]: '登录',
  [`${L}.subtitle`]: '使用已有的 Formosa 会员账号。',
  [`${L}.methodLabel`]: '登录方式',
  [`${L}.account`]: '账号',
  [`${L}.password`]: '密码',
  [`${L}.rememberMe`]: '记住我',
  [`${L}.forgotPassword`]: '忘记密码？',
  [`${L}.submit`]: '登录',
  [`${L}.submitting`]: '登录中…',
  [`${L}.guest`]: '以访客浏览',
  [`${L}.noAccount`]: '还没有账号？',
  [`${L}.registerLink`]: '注册',
  [`${L}.failed`]: '无法登录，请稍后再试。',

  [`${R}.title`]: '创建账号',
  [`${R}.subtitle`]: '使用 Formosa 会员账号注册。',
  [`${R}.methodLabel`]: '注册方式',
  [`${R}.username`]: '用户名',
  [`${R}.password`]: '密码（6–12 字，不含空格）',
  [`${R}.nickname`]: '显示名称（选填）',
  [`${R}.inviterRequired`]: '邀请码（必填）',
  [`${R}.inviterOptional`]: '邀请码（选填）',
  [`${R}.verifyCode`]: '验证码',
  [`${R}.sendCode`]: '发送验证码',
  [`${R}.sendingCode`]: '发送中…',
  [`${R}.resendIn`]: '请于 {count} 秒后重发',
  [`${R}.codeSent`]: '验证码已发送',
  [`${R}.codeFailed`]: '验证码发送失败',
  [`${R}.emailRequired`]: '请输入电子邮箱',
  [`${R}.mobileRequired`]: '请输入手机号码',
  [`${R}.agreeRequired`]: '请先同意用户条款与隐私政策',
  [`${R}.agree`]: '我同意用户条款与隐私政策',
  [`${R}.legalLinksLabel`]: '条款与政策',
  [`${R}.terms`]: '用户条款',
  [`${R}.privacy`]: '隐私政策',
  [`${R}.submit`]: '创建账号',
  [`${R}.submitting`]: '创建中…',
  [`${R}.failed`]: '注册失败',
  [`${R}.haveAccount`]: '已经有账号？',
  [`${R}.loginLink`]: '登录',

  [`${C}.trigger`]: '创建',
  [`${C}.open`]: '创建内容',
  [`${C}.close`]: '关闭创建菜单',
  [`${C}.title`]: '新增',
  [`${C}.subtitle`]: '选择你想开始的内容',
  [`${C}.cancel`]: '取消',
  [`${C}.post.label`]: '发布帖子',
  [`${C}.post.description`]: '分享多图、GIF、贴图或音乐',
  [`${C}.journey.label`]: '创建行程',
  [`${C}.journey.description`]: '沿用现有的创建行程流程',
  [`${C}.group-trip.label`]: '发起组团',
  [`${C}.group-trip.description`]: '从自己已发布的行程发起',
  [`${C}.checkin.label`]: '打卡',
  [`${C}.checkin.description`]: '记录你到过的地点',
};

export const getTravelEntryMessage = createFlatMessageLookup({
  zh_TW: travelEntryMessagesZhTW,
  en_US: travelEntryMessagesEnUS,
  zh_CN: travelEntryMessagesZhCN,
});
